import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
const money = (v:any) => Number(v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });
type Props = { cards: any };
class PpmSummaryPanel extends React.Component<Props> {
  render() {
    const c = this.props.cards || {};
    const items = [
      ['Total', money(c.total || c.tam)],
      ['Fonctionnement', money(c.fonctionnement || c.fam)],
      ['Investissement', money(c.investissement || c.iam)],
      ['Lines', c.linecount || c.lct || 0],
      ['Superactivities', c.superactivitycount || 0],
      ['Status', c.status || c.pst || '-'],
    ];
    return <Grid container spacing={2}>{items.map(([l,v]) => <Grid size={{ xs: 6, sm: 4, md: 2 }} key={String(l)}><Card><CardContent><Typography variant="caption" color="text.secondary">{l}</Typography><Typography variant="h6" sx={{fontWeight:700}}>{v}</Typography></CardContent></Card></Grid>)}</Grid>;
  }
}
export default PpmSummaryPanel;
